import React, { Component } from "react";
import { Alert, Row, Col, Button, FormGroup, Label, Input, Spinner } from 'reactstrap';
import axios from '../../utils/request';

export class SanQiHuYuInviteReject extends Component {
    constructor(props) {
        super(props);
        this.state = {
            message: "",
            loading: true,
            code: "",
            tenantId: - 1,
            personId: "",
            jobId: "",
            reason: "",
            showError: false,
            showErrorMsg: "",
            refuseReason: []
        }
    };

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const personId = urlParams.get("applicantId");
        const jobId = urlParams.get("jobId");
        const tenantId = urlParams.get("tenantId");
        if (!personId) {
            this.setState({ code: "500", message: "参数异常，请联系管理员。", loading: false });
            return;
        }
        this.setState({ code: "200", message: "", tenantId: tenantId, personId: personId, jobId: jobId });
        this.getRefueseReason(tenantId)
    };

    getRefueseReason=(tenantId)=>{
        

        const params = {
            "tenantId": tenantId
        }

        const bodyString = JSON.stringify(params);

        axios.post(
            "/api/SanQiHuYu/GetRefuseReason",
            bodyString,
            {
                params: { tenantId: tenantId },
                headers: { "Content-Type": "application/json" }
            }
        ).then(res => {
            const codeValue = res.data.code;
            console.log(res.data.data);
            if (codeValue === "500") {
                this.setState({ code: codeValue, message: res.data.message, loading: false })
                return;
            }           
            else {
                this.setState({ code: "200", refuseReason: res.data.data, loading: false })
            }
        }).catch(reason => {
            this.setState({ code: "500", message: "发起失败，请稍后再试！", loading: false })
            return;
        }).finally(
        );
    };


    query = {
        reason: {
            value: '',
            validata: [
                {
                    errMessage: "请选择一个拒绝理由",
                    test: (value) => {
                        return value;
                    }
                }
            ]
        }
    };

    showError = (text) => {
        this.setState({ showErrorMsg: text, showError: true })
    }

    errDismiss = () => {
        const isErrorShowing = this.state.showError;
        if (isErrorShowing) {
            this.setState({ showError: false })
        }
        else {
            this.setState({ showError: true })
        }
    };

    handleChange = (name, event) => {
        var newState = {};
        console.log(name);
        console.log(event);
        newState["reason"] = name;

        this.setState(newState);
        for (let key in this.query) {
            if (key === "reason") {
                this.query[key].value = name;
            }
        }
    };

    valiForm = () => {
        for (let key in this.query) {
            let item = this.query[key];
            let valiItem = item.validata;
            if (valiItem !== undefined) {
                for (let k in valiItem) {
                    let valis = valiItem[k];
                    if (!valis.test(item.value)) {
                        this.showError(valis.errMessage);
                        return false;
                    }
                }
            }
        }
        return true;
    }

    submitFun = () => {
        if (this.valiForm() !== true) {
            return false;
        }

        this.setState({ loading: true });

        const params = {
            "tenantId": this.state.tenantId,
            "applicantId": this.state.personId,
            "jobId": this.state.jobId,
            "accept": "2",
            "message": this.state.reason
        }

        const bodyString = JSON.stringify(params);
       
        axios
            .post(
                "/api/SanQiHuYu/Invitation",
                bodyString,
                {
                    params: { tenantId: this.state.tenantId, applicantId: this.state.personId, jobId: this.state.jobId, accept: "2", message: this.state.reason},
                    headers: { "Content-Type": "application/json" }
                }
            )
            .then(res => {
                const codeValue = res.data.code;
                let msg = "";
                if (codeValue === "500") {
                    
                    this.setState({ code: codeValue, message: res.data.message, loading: false });
                }
                else {
                    window.location.href = "/sanqihuyu_invite_reject_success";                    
                }
            })
            .catch(reason => {
                this.setState({ code: "500", message: "发起失败，请稍后再试！", loading: false })
            })
            .finally(
                this.setState({ code: "200", message: "", loading: false })
            );
    };

    renderHtml = () => {
        return (
            <Col sm="12" md={{ size: 8, offset: 2 }} style={{ marginTop: '50px' }}>
                <Alert color="light">
                    <h4 className="alert-heading">请答复不参加原因:</h4>
                    <hr />
                    <Row>
                        {this.state.refuseReason.map(el => (
                            <Col sm="12" md="6" style={{ marginTop: '12pt' }} key={ el.value}>
                                <FormGroup check>
                                    <Label check>
                                        <Input type="radio" name="reason" value={el.value} onChange={this.handleChange.bind(this, el.value)} />{el.reason}
                                    </Label>
                                </FormGroup>
                            </Col>
                        ))}                        
                    </Row>
                    
                    <Row>
                        <Col sm="12" md="12" style={{ marginTop: '12pt' }}>
                            <Alert color="danger" isOpen={this.state.showError} toggle={this.errDismiss}>{this.state.showErrorMsg}</Alert>
                            <hr className="my-2" />
                            <Button color="primary" onClick={this.submitFun}>提交</Button>
                        </Col>
                    </Row>
                </Alert>
            </Col>
        );
    }

    render() {
        let contents = ""
        if (this.state.loading) {
            contents = ""
            contents = <div style={{ textAlign: "center", padding: "15px" }}>
                <Spinner type="grow" color="primary" />
                <Spinner type="grow" color="secondary" />
                <Spinner type="grow" color="success" />
                <Spinner type="grow" color="danger" />
                <Spinner type="grow" color="warning" />
                <Spinner type="grow" color="info" />
                <Spinner type="grow" color="light" />
                <Spinner type="grow" color="dark" />
            </div>
        } else {
            contents = ""
            if (this.state.code === "200" && this.state.message === "") {
                contents = this.renderHtml()
            } else {
                contents = <p><em>Error...</em> | Code = {this.state.code} | Message = {this.state.message}</p>
            }
        }

        return (
            <div>{contents}</div>
        );
    }
}